/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadLinkResponse
 */
export interface UploadLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadLinkResponse
     */
    url: string | null;
}

/**
 * Check if a given object implements the UploadLinkResponse interface.
 */
export function instanceOfUploadLinkResponse(value: object): value is UploadLinkResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UploadLinkResponseFromJSON(json: any): UploadLinkResponse {
    return UploadLinkResponseFromJSONTyped(json, false);
}

export function UploadLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function UploadLinkResponseToJSON(json: any): UploadLinkResponse {
    return UploadLinkResponseToJSONTyped(json, false);
}

export function UploadLinkResponseToJSONTyped(value?: UploadLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

